
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as hcGZRNgg_xO_VQ7R2NRs_45MjPBbdIYzW_45DGkZaY6osv1nkMeta } from "/workspace/src/pages/hc.vue?macro=true";
import { default as setJWgJWnTIQPuySevVxj28j2YNzSOhikDknDPNWIKsPPQMeta } from "/workspace/src/pages/set.vue?macro=true";
import { default as indexkFppGvffhEyiBhi55nmjQFN_BKzm3BwjgldYNaRexy4Meta } from "/workspace/src/pages/index.vue?macro=true";
import { default as logingxVtisFU7SYxdsC0gCQL8nQ3urm9ZMsHtTShtPN9mmgMeta } from "/workspace/src/pages/login.vue?macro=true";
import { default as searchE41ENm_jSWZVPqrKF5b68he2R5ntktfid6owgGy_NyIMeta } from "/workspace/src/pages/search.vue?macro=true";
import { default as regularExiROhr8c9eiEAowNh95LDBZkTVaCF4NMyBVwin94vkMeta } from "/workspace/src/pages/regular.vue?macro=true";
import { default as tokuteiohPhJM7rlytgxgO95l1B2Xol1C1NDVzpADtET892HRAMeta } from "/workspace/src/pages/tokutei.vue?macro=true";
import { default as troublenULUTKF5ewJxcugTOPzBnc90RIPJENX6TuXU_45zMqzkoMeta } from "/workspace/src/pages/trouble.vue?macro=true";
import { default as welcomewiMOQ72FzhC_45MGzTRfak_45Ya5b4MgTtK7fONpvNcv2WYMeta } from "/workspace/src/pages/welcome.vue?macro=true";
import { default as indexRKadW6RxNKZsNwPGRA2cA_zdDaNTpDLagJU_45wUE6cAkMeta } from "/workspace/src/pages/faq/index.vue?macro=true";
import { default as _91id_939FOVZPU6mlGX9HL3qDek5NLHbI2XZXhe_453k8EPvRBkoMeta } from "/workspace/src/pages/news/[id].vue?macro=true";
import { default as indexZJmAE_GeBs4Te4LzYsr5fj8j0GW36Cd0TFBXwI_458_45GoMeta } from "/workspace/src/pages/cart/index.vue?macro=true";
import { default as indexoLQxSbepNV6UVY1000MoxIgum0srRw0Yzy62yJE4vUwMeta } from "/workspace/src/pages/news/index.vue?macro=true";
import { default as _91id_93z03t2J2Wfx1nPfVEIlu4Vf73yR44i7x3AKcwa1zAHhIMeta } from "/workspace/src/pages/voice/[id].vue?macro=true";
import { default as indexiKfju6Pb5_45QxlbOPtwZBkv0SjJmR1uj4cEN77ldXXWIMeta } from "/workspace/src/pages/guide/index.vue?macro=true";
import { default as indexyd8Wz5sr4nJlRc443BxppRgqfr7pGtgDmkaIPV_45dpEYMeta } from "/workspace/src/pages/voice/index.vue?macro=true";
import { default as indexLpKDV6UNMPIcM9Hil4V5Upj1KtFp7xIq__fjHeC1lrUMeta } from "/workspace/src/pages/mypage/index.vue?macro=true";
import { default as indexaXtD70sSaMWMKncOGoKdgEYHYCNmeCbddqNfjwFDACMMeta } from "/workspace/src/pages/contact/index.vue?macro=true";
import { default as indexQQr5HlBzdm2rQSQb_45eA2dpIjVVxrZUZS1RwYRNnE4l0Meta } from "/workspace/src/pages/enquete/index.vue?macro=true";
import { default as _91id_93QcRLgsmWmdM5oz8fwDr_45zkH3gO_SADXV658ulyuFqFkMeta } from "/workspace/src/pages/products/[id].vue?macro=true";
import { default as indexCqhP9jLjYF7zEnoEohSoUux6jaOZ0B35oNjrJPiHt74Meta } from "/workspace/src/pages/cart/set/index.vue?macro=true";
import { default as index_ZfNR_SSQm8igmCOw2ov6QIqsIoNlseRhzzZKMrJrK0Meta } from "/workspace/src/pages/checkout/index.vue?macro=true";
import { default as indexGpSLS7Ew_Mn750GXg6s5vsF19TY2EnDUXndrZQwHcqoMeta } from "/workspace/src/pages/register/index.vue?macro=true";
import { default as signupckvswDS0wL5lEJSXO_45fpLUu0Ro2AO4dEnGM_JKAgK84Meta } from "/workspace/src/pages/register/signup.vue?macro=true";
import { default as completefYoi66z_Uae9DZDICmeVY5OFDfBBjrnRDFA2t14sszEMeta } from "/workspace/src/pages/checkout/complete.vue?macro=true";
import { default as indexEgqdBtMB3wAO7VQLZ39_45D_47yKCLLTAp5ZGyglXgLaYMeta } from "/workspace/src/pages/mypage/user/index.vue?macro=true";
import { default as completeU3uOC0RJKlelzAZOokQYe3Q0jUr2N3A396HizoAYNuYMeta } from "/workspace/src/pages/register/complete.vue?macro=true";
import { default as indexUT4SOrVB_457D0vBh0RPuJ0uumV9J0Zm_UjQ_2IRNk0gAMeta } from "/workspace/src/pages/mypage/contact/index.vue?macro=true";
import { default as indexKC_45kBzPC_45CfoFl3TwezVv_74nxRVcSuC_LQAC8T9968Meta } from "/workspace/src/pages/password/reset/index.vue?macro=true";
import { default as indexVi6twEGvA78O_45L2rIwjM4LS22bjfVKatMuNLPICFFcAMeta } from "/workspace/src/pages/mypage/password/index.vue?macro=true";
import { default as issuedfDXAN04M7Jxsw6Wqo8dI4Kfej2udgFeeI__45vCD7WAyYMeta } from "/workspace/src/pages/password/reset/issued.vue?macro=true";
import { default as index6sDx991uLw_mWdfJ0rFtOJ3jlVt3iwuBe2TEqWtAaOoMeta } from "/workspace/src/pages/special-message/index.vue?macro=true";
import { default as indexeUVqMIOhBalDOWEbBPoZ9QvDdtvURpCoB4VLzMh4OJ4Meta } from "/workspace/src/pages/customer-enquete/index.vue?macro=true";
import { default as _91token_931jncSyKzCkjUtB77Om_45_vFwV_452P_211GWbtd_45Za60cIMeta } from "/workspace/src/pages/password/reset/[token].vue?macro=true";
import { default as indexhmlsHH_ZtYEFLC83od6C_45qMvHFxmhe_AHrTw_452LOUqoMeta } from "/workspace/src/pages/mypage/withdrawal/index.vue?macro=true";
import { default as completekLBa9iYXXl1n0ou6s9ch0yhf2zr_qz7Yh9AmkpER_458sMeta } from "/workspace/src/pages/password/reset/complete.vue?macro=true";
import { default as indexOhvl91rfmBaO7sIsP33aSraOddp2fNKCSdPq5FiNqxkMeta } from "/workspace/src/pages/mypage/mypage-base/index.vue?macro=true";
import { default as _91id_93q6Wh8oN1GrdJVgWHDmoepZr8GpBhjIC_45RtwwsEXg5KoMeta } from "/workspace/src/pages/mypage/order-history/[id].vue?macro=true";
import { default as indexYrZe1BigHJ_45iw0FvDRQjUID4R18XC0rhLb0bI_451V7sIMeta } from "/workspace/src/pages/mypage/regular-info/index.vue?macro=true";
import { default as customer_45harassment_45policy8sTZU4hTtEb_W1YucjXzTP7fEIfo04ntDslM_7hnsqUMeta } from "/workspace/src/pages/customer-harassment-policy.vue?macro=true";
import { default as indexTMq3dYTmxbr8M8NuTP0_l_qQD3tdt_Gye4DJew36_T0Meta } from "/workspace/src/pages/mypage/order-history/index.vue?macro=true";
import { default as completePmTp9D32_u2lyAlctd9kgT_8IywUfkg484twCvM0e3sMeta } from "/workspace/src/pages/mypage/withdrawal/complete.vue?macro=true";
import { default as email_45verificationdaCczqYXEMvU3AguwH9iKPmIUPijRWa_45Gz8ISYniR_UMeta } from "/workspace/src/pages/register/email-verification.vue?macro=true";
import { default as index4_45ZDgNioeousL15nmzgREuxYWol_4Ve61W38UZakKksMeta } from "/workspace/src/pages/mypage/credit-card/new/index.vue?macro=true";
import { default as _91serialNumber_93DkIDjSy97qLQ5peF37jGu9yfYFXUVUDg_455S8AAIhhhMMeta } from "/workspace/src/pages/customer-enquete/[serialNumber].vue?macro=true";
import { default as completeTEkgZNXznHX_nKj5hZ8VgtVAzTt9MyqnTSpmWs7eAxoMeta } from "/workspace/src/pages/mypage/credit-card/new/complete.vue?macro=true";
import { default as indexeT_45Rd43EWYtYglMST4l_C_45RNsQfQyWlsir5XKwjb4t8Meta } from "/workspace/src/pages/mypage/regular-info/[regularId]/index.vue?macro=true";
import { default as completeg6cLrWoVttUdgW706VBltvTPNZx110pkt3XuYBdj1fgMeta } from "/workspace/src/pages/mypage/regular-info/[regularId]/complete.vue?macro=true";
import { default as component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta } from "/workspace/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I } from "/workspace/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "hc",
    path: "/hc",
    meta: hcGZRNgg_xO_VQ7R2NRs_45MjPBbdIYzW_45DGkZaY6osv1nkMeta || {},
    component: () => import("/workspace/src/pages/hc.vue")
  },
  {
    name: "set",
    path: "/set",
    component: () => import("/workspace/src/pages/set.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/workspace/src/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: logingxVtisFU7SYxdsC0gCQL8nQ3urm9ZMsHtTShtPN9mmgMeta || {},
    component: () => import("/workspace/src/pages/login.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/workspace/src/pages/search.vue")
  },
  {
    name: "regular",
    path: "/regular",
    component: () => import("/workspace/src/pages/regular.vue")
  },
  {
    name: "tokutei",
    path: "/tokutei",
    component: () => import("/workspace/src/pages/tokutei.vue")
  },
  {
    name: "trouble",
    path: "/trouble",
    component: () => import("/workspace/src/pages/trouble.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    component: () => import("/workspace/src/pages/welcome.vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/workspace/src/pages/faq/index.vue")
  },
  {
    name: "news-id",
    path: "/news/:id()",
    component: () => import("/workspace/src/pages/news/[id].vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/workspace/src/pages/cart/index.vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/workspace/src/pages/news/index.vue")
  },
  {
    name: "voice-id",
    path: "/voice/:id()",
    meta: _91id_93z03t2J2Wfx1nPfVEIlu4Vf73yR44i7x3AKcwa1zAHhIMeta || {},
    component: () => import("/workspace/src/pages/voice/[id].vue")
  },
  {
    name: "guide",
    path: "/guide",
    component: () => import("/workspace/src/pages/guide/index.vue")
  },
  {
    name: "voice",
    path: "/voice",
    component: () => import("/workspace/src/pages/voice/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":["auth"]},
    component: () => import("/workspace/src/pages/mypage/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/workspace/src/pages/contact/index.vue")
  },
  {
    name: "enquete",
    path: "/enquete",
    meta: {"middleware":["auth","buy-after-enquete-check"]},
    component: () => import("/workspace/src/pages/enquete/index.vue")
  },
  {
    name: "products-id",
    path: "/products/:id()",
    component: () => import("/workspace/src/pages/products/[id].vue")
  },
  {
    name: "cart-set",
    path: "/cart/set",
    meta: {"middleware":["validate-cart-set-query"]},
    component: () => import("/workspace/src/pages/cart/set/index.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: index_ZfNR_SSQm8igmCOw2ov6QIqsIoNlseRhzzZKMrJrK0Meta || {},
    component: () => import("/workspace/src/pages/checkout/index.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("/workspace/src/pages/register/index.vue")
  },
  {
    name: "register-signup",
    path: "/register/signup",
    meta: signupckvswDS0wL5lEJSXO_45fpLUu0Ro2AO4dEnGM_JKAgK84Meta || {},
    component: () => import("/workspace/src/pages/register/signup.vue")
  },
  {
    name: "checkout-complete",
    path: "/checkout/complete",
    meta: {"middleware":["auth","validate-order-key"]},
    component: () => import("/workspace/src/pages/checkout/complete.vue")
  },
  {
    name: "mypage-user",
    path: "/mypage/user",
    meta: {"middleware":["auth"]},
    component: () => import("/workspace/src/pages/mypage/user/index.vue")
  },
  {
    name: "register-complete",
    path: "/register/complete",
    component: () => import("/workspace/src/pages/register/complete.vue")
  },
  {
    name: "mypage-contact",
    path: "/mypage/contact",
    meta: {"middleware":["auth"]},
    component: () => import("/workspace/src/pages/mypage/contact/index.vue")
  },
  {
    name: "password-reset",
    path: "/password/reset",
    component: () => import("/workspace/src/pages/password/reset/index.vue")
  },
  {
    name: "mypage-password",
    path: "/mypage/password",
    meta: {"middleware":["auth"]},
    component: () => import("/workspace/src/pages/mypage/password/index.vue")
  },
  {
    name: "password-reset-issued",
    path: "/password/reset/issued",
    component: () => import("/workspace/src/pages/password/reset/issued.vue")
  },
  {
    name: "special-message",
    path: "/special-message",
    meta: { ...(index6sDx991uLw_mWdfJ0rFtOJ3jlVt3iwuBe2TEqWtAaOoMeta || {}), ...{"middleware":"redirect-if-not-special-rank"} },
    component: () => import("/workspace/src/pages/special-message/index.vue")
  },
  {
    name: "customer-enquete",
    path: "/customer-enquete",
    meta: {"middleware":["auth"]},
    component: () => import("/workspace/src/pages/customer-enquete/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password/reset/:token()",
    meta: {"middleware":["show-password-reset-form"]},
    component: () => import("/workspace/src/pages/password/reset/[token].vue")
  },
  {
    name: "mypage-withdrawal",
    path: "/mypage/withdrawal",
    meta: {"middleware":["auth"]},
    component: () => import("/workspace/src/pages/mypage/withdrawal/index.vue")
  },
  {
    name: "password-reset-complete",
    path: "/password/reset/complete",
    component: () => import("/workspace/src/pages/password/reset/complete.vue")
  },
  {
    name: "mypage-mypage-base",
    path: "/mypage/mypage-base",
    meta: {"middleware":["auth"]},
    component: () => import("/workspace/src/pages/mypage/mypage-base/index.vue")
  },
  {
    name: "mypage-order-history-id",
    path: "/mypage/order-history/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/workspace/src/pages/mypage/order-history/[id].vue")
  },
  {
    name: "mypage-regular-info",
    path: "/mypage/regular-info",
    meta: {"middleware":["auth"]},
    component: () => import("/workspace/src/pages/mypage/regular-info/index.vue")
  },
  {
    name: "customer-harassment-policy",
    path: "/customer-harassment-policy",
    component: () => import("/workspace/src/pages/customer-harassment-policy.vue")
  },
  {
    name: "mypage-order-history",
    path: "/mypage/order-history",
    meta: {"middleware":["auth"]},
    component: () => import("/workspace/src/pages/mypage/order-history/index.vue")
  },
  {
    name: "mypage-withdrawal-complete",
    path: "/mypage/withdrawal/complete",
    meta: {"middleware":["withdrawal-complete"]},
    component: () => import("/workspace/src/pages/mypage/withdrawal/complete.vue")
  },
  {
    name: "register-email-verification",
    path: "/register/email-verification",
    meta: email_45verificationdaCczqYXEMvU3AguwH9iKPmIUPijRWa_45Gz8ISYniR_UMeta || {},
    component: () => import("/workspace/src/pages/register/email-verification.vue")
  },
  {
    name: "mypage-credit-card-new",
    path: "/mypage/credit-card/new",
    meta: {"middleware":["auth"]},
    component: () => import("/workspace/src/pages/mypage/credit-card/new/index.vue")
  },
  {
    name: "customer-enquete-serialNumber",
    path: "/customer-enquete/:serialNumber()",
    meta: {"middleware":"check-customer-enquete-status"},
    component: () => import("/workspace/src/pages/customer-enquete/[serialNumber].vue")
  },
  {
    name: "mypage-credit-card-new-complete",
    path: "/mypage/credit-card/new/complete",
    meta: completeTEkgZNXznHX_nKj5hZ8VgtVAzTt9MyqnTSpmWs7eAxoMeta || {},
    component: () => import("/workspace/src/pages/mypage/credit-card/new/complete.vue")
  },
  {
    name: "mypage-regular-info-regularId",
    path: "/mypage/regular-info/:regularId()",
    meta: {"middleware":["validate-regular-id-param","auth"]},
    component: () => import("/workspace/src/pages/mypage/regular-info/[regularId]/index.vue")
  },
  {
    name: "mypage-regular-info-regularId-complete",
    path: "/mypage/regular-info/:regularId()/complete",
    meta: {"middleware":["validate-regular-id-param","auth"]},
    component: () => import("/workspace/src/pages/mypage/regular-info/[regularId]/complete.vue")
  },
  {
    path: "/mypage/order_history",
    redirect: "/mypage/order-history"
  },
  {
    path: "/mypage/mypage_base",
    redirect: "/mypage/mypage-base"
  },
  {
    path: "/mypage/credit_card",
    redirect: "/mypage/credit-card/new"
  },
  {
    path: "/mypage/regular_info",
    redirect: "/mypage/regular-info"
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/faq/basic",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/faq/site-use",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/guide/order",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/guide/payment",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/guide/shipping",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/guide/return",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/guide/mypage",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/functional-food",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/skin-care",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/health-goods",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  }
]